import React from 'react';
import { LinkOutlined } from '@ant-design/icons';

// Comment text with its links clickable (a new tab): a named link, as the
// comment box's Add Link writes it ([Final warning recording](https://...)),
// shows its name; a bare web address shows as itself.
const LINK_RE = /(\[[^\]\n]+\]\(https?:\/\/[^\s)]+\)|https?:\/\/[^\s]+)/g;
const NAMED_RE = /^\[([^\]\n]+)\]\((https?:\/\/[^\s)]+)\)$/;

export default function LinkifiedText({ text }) {
  if (!text) return null;
  const parts = String(text).split(LINK_RE);
  return parts.map((part, i) => {
    const named = NAMED_RE.exec(part || '');
    if (named) {
      return (
        <a key={i} href={named[2]} target="_blank" rel="noopener noreferrer" title={named[2]}
          onClick={(e) => e.stopPropagation()}>
          <LinkOutlined style={{ marginRight: 4 }} />{named[1]}
        </a>
      );
    }
    return /^https?:\/\//.test(part || '')
      ? (
        <a
          key={i}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
          {part}
        </a>
      )
      : part;
  });
}
